import { StatusEnum } from 'src/app/shared/models';
import { StatusEvent } from 'src/app/shared/warehouse-models';
import { ArrivalReciept } from './ArrivalReciept/arrival-reciept-model';



export class ArrivalNotice {
  [key: string]: unknown;
  startDate!: Date;
  endDate!: Date;
  status!: StatusEnum;
  lastHandledBy!: string;
  statusEvents!: StatusEvent[];
  timeStamp!: string;
  id!: number;
  info!: string;
  attachmentLocation!: string;
  unloadingDuration!: string;
  loppusijoituskohde!: string;
  recipient!: string;
  contactName!: string;
  contactPhone!: string;
  materialMover!: string;
  companyName!: string;
  companyId!: string;
  linkedWorkOrderId!: number;
  projectId!: number;
  projectName!: string;
  unloadingPlaceId!: number;
  unloadingPlaceName!: string;
  ownerName!: string;
  ownerId!: string;
  v3RefId!: number;
  content: ArrivalContent[] = [];
  files: FileMetadata[] = [];
  reciept:ArrivalReciept|undefined;

  constructor(data: Partial<ArrivalNotice>) {
    Object.assign(this, data);
  }
}
export class ArrivalContent {
  productName!: string;
  productCode!: string;
  productManufacturer!: string;
  quantity!: number;
  unit!: string;
}
export interface FileMetadata {
  fileID: number;
  arrivalNoticeId: number | null;
  fileName: string;
  blobName: string;
  blobUrl: string;
  contentType: string;
  fileSize: number;
  uploadDate: string;
}


